 <template >
 <v-dialog v-model="createdialog" persistent max-width="700px">
      <v-btn fab  slot="activator" color="red" dark> <v-icon>add</v-icon></v-btn>    
 <v-card color="grey lighten-4" flat offset-md4 >
      <v-container grid-list-md pa-3>
            <v-flex xs1 style="float:right">
              <v-btn flat fab small @click="createdialog=false"> <v-icon>close</v-icon></v-btn>
          </v-flex>
        <v-layout row wrap>
          <v-flex xs12>
            <div style="color: purple; text-align:center;"><h4>Add new Text</h4></div>
          </v-flex>
          <v-flex xs12>
          <v-flex xs6>
        Point :{{interestPoint}}
            </v-flex>
               <v-layout row wrap>
             <v-flex xs6>
        <v-text-field
          name="pointId"
          label="Point ID"
          :value="'Id: '+ (max +1)"
          disabled
          single-line
        ></v-text-field>
            </v-flex>
              <v-flex xs6>
        <v-select
          v-model="infoTSchType"
          name="School"
          label="Select School type"
          :items="avSchool"
          single-line
        ></v-select>
            </v-flex>
               <v-flex xs6>
        <v-select
          v-model="lang"
          name="Lang"
          label="Select language"
          :items="avLang"
          single-line
        ></v-select>
            </v-flex>
            </v-layout>
          </v-flex>
          <v-layout row>
          <v-flex xs12>
            <v-text-field 
            name="title" 
            label="Title"
            id="title"
            v-model="infoTTitle"
            maxlength="80"
            required></v-text-field>
          </v-flex>
          </v-layout>
          <v-flex xs12 >
            <v-text-field 
            name="abbreviation" 
            label="Abbreviation"
            id="abbr"
             v-model="infoTAbbr"
             maxlength="50"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Period"
               v-model="infoTPeriod"
               maxlength="200"
              
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field box multi-line 
            label="Description"
            name="description"
            id="desc"
             v-model="infoTText"
            required></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Source"
                v-model="infoTSource"
              
            ></v-text-field>
          </v-flex>
            <v-flex xs12>
          </v-flex>

      <div style="margin-left:44%;">
            <v-spacer></v-spacer>
          <v-btn @click="onSubmitChanges" color="red" style="color:white;" 
          :disabled="!formIsValid"
          > Create Text </v-btn>
</div>
        </v-layout>
      </v-container>
    </v-card>
    </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      lang:"",
      interestPoint: this.$route.params.id,
      infoTID: "",
      avSchool: ["Γενικής Παιδείας", "Ειδικής Παιδείας"],
      avLang: ["English","Greek"],
      createdialog: false,
      infoTSchType: null,
      infoTTitle: "",
      infoTAbbr: "",
      infoTPeriod: "",
      infoTText: "",
      infoTSource: "",  
    };
  },
  computed: {
    formIsValid() {
      return this.infoTTitle !== "" && this.infoTText !== "" &&this.infoTSchType!==null && this.lang!== "";
    },
    max(){
        return this.$store.getters.maxTextId
    }
  },
  methods: {
    onSubmitChanges() {
      if (!this.formIsValid) {
        return;
      }
      var loption;
      var soption;
      if(this.infoTSchType==='Γενικής Παιδείας'){
          soption= 1;
      }
      else {
          soption=2;
      }
      if(this.lang==='English'){
          loption= 1;
      }
      else {
          loption=2;
      }
      this.createdialog = false;
      const textData = {
        infoTTitle: this.infoTTitle,
        infoTAbbr: this.infoTAbbr,
        infoTPeriod: this.infoTPeriod,
        infoTText: this.infoTText,
        infoTSchType: soption,
        infoTSource: this.infoTSource,
        infoTID:this.max +1,
        interestPoint: Number(this.interestPoint),
        infoTLang: loption,
        createdBy: this.$store.getters.user.email
      };
      this.$store.dispatch("createText", textData);
      
      this.lang="";
      this.interestPoint= this.$route.params.id;
      this.infoTID= "";
      this.avSchool= ["1", "2"];
      this.avLang= ["English","Greek"];
      this.createdialog= false;
      this.infoTSchType= null;
      this.infoTTitle= "";
      this.infoTAbbr= "";
      this.infoTPeriod= "";
      this.infoTText= "";
      this.infoTSource= "";  
      this.$store.dispatch('loadSpotContent', Number(this.$route.params.id));
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/edit/createText.vue